import React from "react"
import {TextModel} from "models/Text"
import {breakpoints} from "@next/themes"
import {useMediaQuery} from "../../../hooks/useMediaQuery"
import {Container, SearchBar, SearchIcon, ClearIcon, Icon, Input} from "./components"
import env from "../../../config/env"

const SEARCH_ICON = "next_search-grey.svg"

interface Props {
    setFreeTextFilterSearch: (e: React.SyntheticEvent, filterName: string) => void
    clearFreeTextSearchForFilter: (filterName: string) => void
    freeTextFilterSearch: {[key: string]: string}
    text: TextModel
    filterName: string
    filterDisplayName: string
}

const FilterSearchBar = ({
    setFreeTextFilterSearch,
    clearFreeTextSearchForFilter,
    freeTextFilterSearch,
    text,
    filterName,
    filterDisplayName,
}: Props) => {
    const isSmallScreen = useMediaQuery(`(max-width:${breakpoints.values.sm - 1}px)`)
    return (
        <Container>
            <SearchBar data-testid="plp-tabbed-brand-search-bar">
                <Input
                    autoComplete="off"
                    placeholder={`${text.pages.filters.searchCategory} ${filterDisplayName}s`}
                    onChange={e => setFreeTextFilterSearch(e, filterName)}
                    value={freeTextFilterSearch[filterName] || ""}
                    data-testid="plp-tabbed-brand-search-bar-input"
                    id="plp-tabbed-brand-search-bar-input"
                    isSmallScreen={isSmallScreen}
                />
                {(freeTextFilterSearch[filterName] === undefined || freeTextFilterSearch[filterName] === "") && (
                    <SearchIcon>
                        <Icon
                            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/next_search-black.svg`}
                            alt={text.imageAlts.tabbedSearchCategory}
                        />
                    </SearchIcon>
                )}
                {freeTextFilterSearch[filterName] && freeTextFilterSearch[filterName] !== "" && (
                    <ClearIcon isSmallScreen={isSmallScreen}>
                        <Icon
                            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/clear.svg`}
                            alt={text.imageAlts.tabbedSearchCategory}
                            onClick={() => clearFreeTextSearchForFilter(filterName)}
                            data-testid="plp-tabbed-category-search-bar-clear"
                        />
                    </ClearIcon>
                )}
            </SearchBar>
        </Container>
    )
}

export default FilterSearchBar
